export const indexStateData = {
  loading: false,
  error: false,
  success: false,
  message: "",
  accessToken: null
};


export const userData = {
  loading: true,
  success: false,
  error: false,
  data: {
    data: {},
  },
};